import React, { useEffect, useState } from "react"
import { CustomHeader } from "../../components/headers/CustomHeader"
import {
  Button,
  Card,
  CardBody,
  IconButton,
  Input,
  Spinner,
  Tooltip,
  Typography,
} from "@material-tailwind/react"
import moment from "moment"
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai"
import { toast } from "react-toastify"
import { DEFAULTPRIMARYCOLOR } from "../../util"

import { DetailDrawer } from "../../components"
import CollectionDetail from "../../components/Details/collection-detail copy"
import { FiDownloadCloud } from "react-icons/fi"
import Papa from "papaparse"
import { useSelector } from "react-redux"
import { RootState } from "../../store/store"
import { RiAdminLine } from "react-icons/ri"
import { DriverAggreateType } from "../../types/query"
import { DRIVERAGGREGATE, GETCOMMISSIONSEARCH } from "../../GraphQl/queries"
import { useQuery } from "@apollo/client"
import { getColorCode } from "../../colorCodes"
import { useDebounceSearch } from "../../hooks/useDebounce"
import { parse } from "path"
import { useSearchCollections } from "../../hooks/useSearch"
import PerPageAndPagination from "../../components/paginations/perpageAndPagination"
import dayjs from "dayjs";

type ResponseType = {
  amount: number
  created_at: string
  created_by: string
  payment_mode: string
  driver_current_balance: number
  id: string
  reference_number: string
  status: string
  company_staff: {
    id: string
    name: string
    phone_number_one: string
  }
  sub_agent: {
    id: string
    first_name: string
    last_name: string
    phone_number: string
  }
  beneficiary: string
  beneficiary_percentage: string
  station_name:string
  driver: {
    account_status: string
    address: string
    driver_code: string
    balance: number
    bank_details: null
    consent: false
    dob: null
    email: string
    gender: string
    id_card_type: string
    nationality: string;
    weekly_income_range: string;
    driver_license_number: string;
    id: string
    id_number: string
    momo_wallet_details: {
      network: string
      number: string
    }
    phone_number_1: string
    phone_number_2: string
    full_name: string
  }
  agent_staff_details: {
    id: string
    phone_number: string
    first_name: string
    last_name: string
  }
}
const Invest2InsureCollection = () => {
  const [searchText, setSearchText] = useState("")
  const [data, setData] = useState<ResponseType[]>([])

  const [loading, setLoading] = useState(false)
  const [selectedRow, setSelectedRow] = useState<ResponseType>()
  const [open, setOpen] = useState<boolean>(false)
  const [totalPageSize, setTotalPageSize] = useState(0)
  const [totalsum, setTotalSum] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)


  const {

    user: stateUser,
    token,
  } = useSelector((state: RootState) => state.auth)

  const defaultStart = moment().subtract(2, "weeks").format("YYYY-MM-DDTHH:mm");
  const defaultEnd = moment().format("YYYY-MM-DDTHH:mm");

  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [tempStartDate, setTempStartDate] = useState(defaultStart);
  const [tempEndDate, setTempEndDate] = useState(defaultEnd);
  const [isFilterLoading, setIsFilterLoading] = useState(false);

  const search = useDebounceSearch<string>(searchText)
  const [searchTerm, setSearchTerm] = useState("");

  // useEffect(() => {
  //   setStartDate(defaultStart);
  //   setEndDate(defaultEnd);
  // }, [defaultStart, defaultEnd]);




  const handleSearch = () => {
    setSearchText(searchTerm)
    setActivePage(0)
    // setStartDate("")
    // setEndDate("")
  }

  const handleTempStartDateChange = (event: any) => {
    const value = event.target.value
    if (value) {
      const dateOnly = value.split("T")[0]; // Extract just the date part
      const formattedValue = `${dateOnly}T00:00`; // Set time to 12:00 AM
      setTempStartDate(formattedValue);
    }
  }

  const handleTempEndDateChange = (event: any) => {
    const value = event.target.value
    if (value) {
      const formattedValue = value
      setTempEndDate(formattedValue)
    }
  }

  const addOneDayToDate = (date: any) => {
    date.setDate(date.getDate() + 1)

    return date
  }

  const handleDateChange = () => {
    const start = dayjs(tempStartDate);
    const end = dayjs(tempEndDate);
    const diffInMonths = end.diff(start, 'month', true);



    // if (diffInMonths > 3) {
    //   setTempStartDate(defaultStart);
    //   setTempEndDate(defaultEnd);
    //   toast.error("Date range cannot exceed 3 months.");
    //   return;
    // }
    // setIsFilterLoading(true)


    setTimeout(() => {
      setStartDate(tempStartDate);
      setEndDate(addOneDayToDate(new Date(tempEndDate)));
      setIsFilterLoading(false);
    }, 1000);
  }



  const reset = () => {
    toast.success("Date filters have been reset")
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setTempStartDate(defaultStart);
    setTempEndDate(defaultEnd);
  }

  const [activePage, setActivePage] = useState(0)
  const [pageSize, setPageSize] = useState(10)




  //   useEffect(() => {
  //   const fetchData = async () => {
  //     // if (!startDate || !endDate) return; // Guard clause

  //     setData([]);
  //     setLoading(true);
  //     try {
  //       const api = `${process.env.REACT_APP_BASE_URL}/get-all-collections-from-api`
  //       let endpoint = ""

  //       if (searchText !== "" && (startDate === defaultStart && endDate === defaultEnd)) {
  //         endpoint = `${api}?search=${searchText}`
  //       } else if ((startDate || endDate) && searchText === "") {
  //         endpoint = `${api}?start_date=${startDate}&end_date=${endDate}`
  //       } else if ((startDate !== defaultStart && endDate !== defaultEnd) && searchText !== "") {
  //         endpoint = `${api}?start_date=${startDate}&end_date=${endDate}&search=${searchText}`
  //       }

  //       const res = await fetch(
  //         // `${process.env.REACT_APP_BASE_URL}/get-all-collections?start_date=${startDate}&end_date=${endDate}`,
  //         endpoint,
  //         {
  //           method: "GET",
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );
  //       const req = await res.json();

  //       if (res?.ok) {
  //         if (req?.error) {
  //           // toast.error(req?.data[0]);
  //         } else {
  //           setData(req?.data);
  //           setTotalPageSize(req?.total_records);
  //           setTotalSum(req?.total_sum);
  //         }
  //       }
  //     } catch (error: any) {
  //       toast.error(error?.message ?? "Something went wrong. Try again!");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [activePage, pageSize, token, endDate, startDate, searchText]);

  function useDebounce(value: string, delay: number = 500): string {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
      const handler = setTimeout(() => {
        setDebounced(value);
      }, delay);

      return () => clearTimeout(handler);
    }, [value, delay]);

    return debounced;
  }

  const debouncedSearchText = useDebounce(searchText, 500);

  useEffect(() => {
    const fetchData = async () => {
      // Only guard clause if searchText is empty AND no dates are provided
      if (!debouncedSearchText && (!startDate || !endDate)) return;

      setData([]);
      setLoading(true);

      try {
        const api = `${process.env.REACT_APP_BASE_URL}/get-all-collections-from-api`;

        const queryParams = new URLSearchParams();

        // If there's a search term, ignore date filters
        if (debouncedSearchText) {
          queryParams.append("search", debouncedSearchText);
        } else if (startDate && endDate) {
          queryParams.append("start_date", dayjs(startDate).format("YYYY-MM-DD"));
          queryParams.append("end_date", dayjs(endDate).format("YYYY-MM-DD"));
        }

        const endpoint = `${api}?${queryParams.toString()}`;

        const res = await fetch(endpoint, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const text = await res.text();

        try {
          const req = JSON.parse(text);
          if (res.ok) {
            setData(req?.data);
            setTotalPageSize(req?.total_records);
            setTotalSum(req?.total_sum);
          } else {
            toast.error(req?.detail || "An error occurred");
          }
        } catch (err) {
          console.error("Invalid JSON:", text);
          toast.error("Unexpected response from server.");
        }
      } catch (error: any) {
        toast.error(error?.message ?? "Something went wrong. Try again!");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [endDate, startDate, debouncedSearchText]);


  const filterData = (filter: ResponseType) => {
    const text = searchText?.toLowerCase() ?? "";
    const formattedDate = moment(filter?.created_at).format("LLL").toLowerCase();

    const referenceNumber = filter?.reference_number?.toLowerCase() ?? "";
    const amount = filter?.amount?.toString().toLowerCase() ?? "";
    const driverBalance = filter?.driver_current_balance?.toString().toLowerCase() ?? "";

    const driver = filter?.driver || {};
    const momoDetails = driver?.momo_wallet_details || {};
    const subAgent = filter?.sub_agent || {};
    const companyStaff = filter?.company_staff || {};

    const driverFullName = driver?.full_name?.toLowerCase() ?? "";
    const driverEmail = driver?.email?.toLowerCase() ?? "";
    const driverGender = driver?.gender?.toLowerCase() ?? "";
    const idCardType = driver?.id_card_type?.toLowerCase() ?? "";
    const driverAddress = driver?.address?.toLowerCase() ?? "";
    const idNumber = driver?.id_number?.toLowerCase() ?? "";
    const phone1 = driver?.phone_number_1?.toLowerCase() ?? "";
    const momoNetwork = momoDetails?.network?.toLowerCase() ?? "";
    const momoNumber = momoDetails?.number?.toLowerCase() ?? "";

    const subAgentFirstName = subAgent?.first_name?.toLowerCase() ?? "";
    const subAgentLastName = subAgent?.last_name?.toLowerCase() ?? "";
    const staffName = companyStaff?.name?.toLowerCase() ?? "";

    const paymentMode = filter?.payment_mode?.toLowerCase() ?? "";

    return (
      referenceNumber.includes(text) ||
      amount.includes(text) ||
      driverBalance.includes(text) ||
      driverFullName.includes(text) ||
      driverEmail.includes(text) ||
      driverGender.includes(text) ||
      idCardType.includes(text) ||
      driverAddress.includes(text) ||
      idNumber.includes(text) ||
      phone1.includes(text) ||
      momoNetwork.includes(text) ||
      momoNumber.includes(text) ||
      subAgentFirstName.includes(text) ||
      subAgentLastName.includes(text) ||
      staffName.includes(text) ||
      paymentMode.includes(text) ||
      formattedDate.includes(text)
    );
  };


  const handlePageChange = (page: number) => {
    setActivePage(page)
  }

  const startIndex = (activePage - 1) * pageSize
  const endIndex = startIndex + pageSize

  const filteredData = data?.filter(filterData)



  const lengthOfItems = filteredData?.length

  const endOffset = activePage + pageSize
  const paginatedData = filteredData?.slice(activePage, endOffset)

  useEffect(() => {
    if (searchText || startDate || endDate) {
      setActivePage(0)

    }
  }, [searchText, startDate, endDate])
  useEffect(() => {
    if (pageSize) {
      setActivePage(0)
      setSearchText("")
      setStartDate("")
      setEndDate("")
    }
  }, [pageSize])
  

  const change = filteredData?.map((item) => {
    return {
      "driver name": item?.driver?.full_name,
      "driver code": item?.driver?.driver_code,
      "driver address": item?.driver?.address,
      "driver email": item?.driver?.email,
      "driver nationality": item?.driver?.nationality,
      "driver income range": item?.driver?.weekly_income_range,
      "driver license number": item?.driver?.driver_license_number,
      "beneficiary": item?.beneficiary,
      "beneficiary percentage": item?.beneficiary_percentage,
      "station name": item?.station_name,
      "payment mode": item?.payment_mode,
      "driver phone Number": item.driver?.phone_number_1,
      "driver dob": item?.driver?.dob,
      gender: item?.driver.gender,
      amount: `GHS ${item?.amount}`,
      "created at": `${moment(item?.created_at).format("LLL")}`,
      reference: item?.reference_number,
      "driver id": item?.driver?.id_card_type,
      "driver id number": item?.driver?.id_number,
      "driver account status": item?.driver?.account_status,
      "company staff": item?.company_staff?.name,
      "company staff phoneNumber":
        item?.company_staff?.phone_number_one?.toString(),
    }
  })


  const userData = stateUser
  const [colors, setColors] = useState<string[]>()

  useEffect(() => {
    if (userData) {
      // const data: UserType = JSON.parse(userData)

      const colors = getColorCode(stateUser?.colors)

      setColors(colors)
    }
  }, [userData, stateUser?.colors])

  //-------------------
  const handleDownload = () => {
    if (change.length === 0) {
      alert("No data to download.")
      return
    }
    // Define custom headers based on the selected filter
    if (startDate || endDate || searchText) {
      const firstItem = change[0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = change?.map((item: any) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })
      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = `${"collection-data"}.csv`
      document.body.appendChild(a)
      // Trigger a click on the link to start the download
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    } else {
      const firstItem = change[0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = change?.map((item: any) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })
      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = `${"collection-data"}.csv`
      document.body.appendChild(a)
      // Trigger a click on the link to start the download
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    }
  }

  //--------------------

  return (
    <>
      <CustomHeader title="Collections" />
      <DetailDrawer
        title="Collection Detail"
        open={open}
        size={400}
        onClose={() => setOpen(false)}
        children={<CollectionDetail content={selectedRow} />}
      />
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-2 md:lg:gap-4 lg:gap-5">
        <Card className="bg-brand-info rounded-lg rounded-tr-[40px] rounded-bl-[50px] shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer">
          <div className="flex flex-row justify-between">
            <div>
              <Typography className="text-2xl font-bold text-white capitalize tracking-wider">
                {loading ? (
                  <Spinner className="mb-2 text-white" />
                ) : (
                  "GH₵ " +
                  totalsum?.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                )}
              </Typography>
              <Typography className="text-sm uppercase font-normal text-white">
                total collection
              </Typography>
            </div>
            <RiAdminLine size={28} color="#cbcbcb" />
          </div>
        </Card>
      </div>

      <div className="mt-10">
        <CardBody className="shadow-sm sticky px-0 py-0  rounded-3xl w-full">
          <div className="bg-black pt-5 rounded-t-2xl">
            <Typography
              variant="h6"
              style={{
                color:
                  colors?.length! > 1
                    ? `${colors![0]?.toLowerCase()}`
                    : `${DEFAULTPRIMARYCOLOR}`,
              }}
              className="px-4 pb-4  font-bold leading-none opacity-70"
            >
              List of Collections{" "}
              <span className=" text-white">{lengthOfItems}</span>
            </Typography>
          </div>
          <div className="w-full">
            <div className="flex flex-col gap-y-6 bg-white  px-3 py-3 ">
              <div className="flex shrink-0 flex-col justify-end gap-2 sm:flex-row">
                <Tooltip content="Export as CSV">
                  <Button
                    onClick={handleDownload}
                    variant="filled"
                    className="capitalize text-sm font-normal flex flex-wrap gap-2"
                    size="sm"
                  >
                    <FiDownloadCloud size={20} />
                    <span>Download csv</span>
                  </Button>
                </Tooltip>
              </div>
              <div className="p-3 flex gap-x-2 items-center flex-col 2xl:flex-row gap-y-3 mb-5">
                <div className="w-full flex flex-row gap-x-2">
                  <Input
                    crossOrigin="anonymous"
                    label="Search"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value)
                      if (e.target.value === "") {
                        setSearchText("")
                      }
                    }}
                    icon={<i className="fas fa-search text-base"></i>}
                  />
                  <Tooltip content="Search">
                    <Button
                      onClick={handleSearch}
                      variant="filled"
                      className="capitalize text-sm font-normal flex flex-wrap gap-2"
                      size="sm"
                    >
                      <span>Search</span>
                    </Button>
                  </Tooltip>

                </div>
                <div className="flex flex-col xl:flex-row gap-3 justify-between mb-0">
                  <div className="flex items-center space-x-2">
                    <label className="font-semibold text-gray-700">From</label>
                    <Input
                      type="datetime-local"
                      value={tempStartDate} // Remove 'Z' for input value
                      onChange={handleTempStartDateChange}
                      size="md"
                      className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                      labelProps={{
                        className: "before:content-none after:content-none",
                      }}
                    />
                  </div>
                  <div className="flex items-center space-x-2">
                    <label className="font-semibold text-gray-700">To</label>
                    <Input
                      type="datetime-local"
                      value={tempEndDate} // Remove 'Z' for input value
                      onChange={handleTempEndDateChange}
                      size="md"
                      className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                      labelProps={{
                        className: "before:content-none after:content-none",
                      }}
                    />
                  </div>
                  <div className="flex items-center space-x-2">
                    <Tooltip content="Apply date filters">
                      <Button
                        onClick={handleDateChange}
                        variant="filled"
                        className="capitalize text-sm font-normal flex flex-wrap gap-2"
                        size="sm"
                      >
                        <span>Filter</span>
                      </Button>
                    </Tooltip>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Tooltip content="Reset All Date filters">
                      <Button
                        onClick={reset}
                        variant="filled"
                        className="capitalize text-sm font-normal flex flex-wrap gap-2"
                        size="sm"
                      >
                        <span>reset</span>
                      </Button>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CardBody className="px-0 py-0">
            <div
              className="overflow-x-auto overflow-y-auto"
              style={{ maxHeight: "65vh" }}
            >
              <table className="w-full bg-white table-auto">
                <thead className="bg-white sticky z-50 top-0">
                  <tr>
                    {[
                      "reference number",
                      "driver's code",
                      "driver's name",
                      "amount collected",
                      "Mode of Payment",
                      "wallet number",
                      "Date Received",
                      "staff/Agent",
                      "account balance",
                    ].map((head) => (
                      <th
                        key={head}
                        className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-4  text-center"
                      >
                        <Typography
                          color="black"
                          className="font-bold text-sm text-black leading-none opacity-70 capitalize"
                        >
                          {head}
                        </Typography>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {paginatedData?.map((item, index: number) => {

                    const isLast = index === paginatedData?.length - 1

                    const classes = isLast
                      ? "px-2 py-3  text-center"
                      : "px-2 py-3 border-b-2 border-blue-gray-50 text-center"

                    return (
                      <tr
                        onClick={() => {
                          setSelectedRow(item)
                          setOpen(true)
                        }}
                        key={index.toString()}
                        className="hover:bg-gray-100 transition-all hover:cursor-pointer"
                      >
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize "
                          >
                            {item?.reference_number}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.driver?.driver_code}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.driver?.full_name}
                          </Typography>
                        </td>

                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS
                            {(item?.amount ?? 0).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.payment_mode}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.payment_mode === "cash"
                              ? "N/A"
                              : item?.driver?.momo_wallet_details?.number}
                          </Typography>
                        </td>

                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {moment(item?.created_at).format("LLL")}
                          </Typography>
                        </td>

                        <td className={classes}>
                          <div className="flex  flex-col gap-2 text-center">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Full name:{" "}
                              <span className="font-normal">
                                {item?.company_staff
                                  ? `${item?.company_staff?.name}`
                                  : `${item?.sub_agent?.first_name} ${item?.sub_agent?.last_name}`}
                              </span>
                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Phone number:{" "}
                              <span className="font-normal">
                                {item?.company_staff
                                  ? item?.company_staff?.phone_number_one
                                  : item?.sub_agent?.phone_number}
                              </span>
                            </Typography>

                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              User type:{" "}
                              <span className="font-normal">
                                {item?.company_staff
                                  ? "Company Staff"
                                  : "Sub Agent"}
                              </span>
                            </Typography>
                          </div>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            GHS
                            {(item?.driver_current_balance ?? 0).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </Typography>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </CardBody>
          {(loading) && (
            <div className="mt-10 flex items-center justify-center">
              <Spinner className="w-10 h-10" />
            </div>
          )}

          {!paginatedData && !loading && !isFilterLoading && (
            <div className="mt-10 flex items-center justify-center">
              <Typography color="white" variant="h6">
                No data found
              </Typography>
            </div>
          )}

          {paginatedData?.length < 1 && !loading && !isFilterLoading && (
            <div className="mt-10 flex items-center justify-center">
              <Typography color="white" variant="h6">
                No data found
              </Typography>
            </div>
          )}
        </CardBody>

        {/* Paginator */}

        {
          // <GeneralPagination
          //   totalItems={
          //     searchText || startDate || endDate
          //       ? lengthOfItems
          //       : totalPageSize!
          //   }
          //   itemsPerPage={pageSize}
          //   currentPage={activePage}
          //   onPageChange={handlePageChange}
          // />

          <PerPageAndPagination
            customColor="white"
            total={
              (searchText || startDate || endDate
                ? lengthOfItems
                : totalPageSize!) ?? 0
            }
            currentPage={activePage}
            setCurrentPage={setActivePage}
            perPage={pageSize}
            setPerPage={setPageSize}
          />
        }
      </div>
    </>
  )
}

export default Invest2InsureCollection
